import React from 'react';

export default function SeoShopLinkCluster({shopLinkClusters}) {
    return (
        <div className="shop-link-cluster__wrapper">
            {shopLinkClusters.map((cluster) => {
                return renderShopLinkCluster(cluster);
            })}
        </div>
    );

    function renderShopLinkCluster(cluster) {
        return (
            <div className="shop-link-cluster__rubric" key={cluster.identifier}>
                <div className="shop-link-cluster__headline">{cluster.identifier}</div>
                {cluster.links.map((link, index) => {
                    return renderLink(link, index);
                })}
            </div>
        );
    }

    function renderLink(link, index) {
        return (
            <div className="shop-link-cluster__link" key={index}>
                <a href={link.url}>{link.text}</a>
            </div>
        );
    }
}
